import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { BulkInsertResult } from '../../models/DTO/BulkInsertResult';
import downloadFile from '../../common/helpers/download.helper';
import { DataFolder, DataFolderDto } from '../../models';
import { IUploadService } from '@services/helpers';

export interface IDataFolderService {
    list(): angular.IPromise<DataFolder>;
    preview(connectionPointGuid: string, fileName: string): angular.IPromise<Blob>;
    delete(connectionPointGuid: string, dataFolderDto: DataFolderDto): angular.IPromise<void>;
    restore(connectionPointGuid: string, dataFolderDto: DataFolderDto): angular.IPromise<void>;
    process(guid: string, fileName: string): angular.IPromise<BulkInsertResult>;
    download(connectionPointGuid: string, fileName: string): angular.IPromise<void>;
    uploads(guid: string, files: File[]): angular.IPromise<boolean>;
}

export class DataFolderService implements IDataFolderService {
    static serviceId = 'dataFolderService';

    private _controllerUrl = 'dataFolder';

    static $inject = ['requestService', 'uploadService'];
    constructor(private _requestService: IRequestService, private _uploadService: IUploadService) {}

    list(): angular.IPromise<DataFolder> {
        const url = `${this._controllerUrl}/list`;
        this._requestService.cleanCacheAtV1(url);
        return this._requestService.getAtV1<DataFolder>(url);
    }

    preview(connectionPointGuid: string, fileName: string): angular.IPromise<Blob> {
        const url = `${this._controllerUrl}/preview/${connectionPointGuid}`;
        const params = angular.toJson(fileName);
        return this._requestService
            .postAtV1<Blob>(url, params, undefined, false, undefined, 'blob', {
                Accept: 'application/octet-stream',
                responseType: 'arraybuffer'
            });
    }

    download(connectionPointGuid: string, fileName: string): angular.IPromise<void> {
        const url = `${this._controllerUrl}/preview/${connectionPointGuid}`;
        const mime = 'application/octet-stream';
        return this._requestService
            .postAtV1<BlobPart>(url, angular.toJson(fileName), undefined, false, undefined, 'blob', { Accept: mime })
            .then((data) => {
                const file = new Blob([data], { type: mime });
                downloadFile(fileName, file);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    delete(connectionPointGuid: string, dataFolderDto: DataFolderDto): angular.IPromise<void> {
        const url = `${this._controllerUrl}/delete/${connectionPointGuid}`;
        const params = angular.toJson(dataFolderDto);
        return this._requestService.postAtV1(url, params);
    }

    restore(connectionPointGuid: string, dataFolderDto: DataFolderDto): angular.IPromise<void> {
        const url = `${this._controllerUrl}/restore/${connectionPointGuid}`;
        const params = angular.toJson(dataFolderDto);
        return this._requestService.postAtV1(url, params);
    }

    process(guid: string, fileName: string): angular.IPromise<BulkInsertResult> {
        const url = `${this._controllerUrl}/process/${guid}`;
        const params = angular.toJson(fileName);
        return this._requestService.postAtV1(url, params);
    }

    uploads(guid: string, files: File[]): angular.IPromise<boolean> {
        const url = `${this._requestService.getUrlV1()}${this._controllerUrl}/uploads/${guid}`;
        return this._uploadService.uploadFiles(url, files);
    }

    private b64DecodeUnicode(str): string {
        return decodeURIComponent(Array.prototype.map.call(atob(str), (c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''));
    }
}
